import { css } from 'linaria';

export const interiorGalleryGridWithCertificate = css`
  && {
    grid-template-rows: 1fr 104px 252px auto;

    @media (--from-desktop) {
      div:nth-of-type(3) {
        grid-row: 2 4;
      }

      div:nth-of-type(5) {
        grid-row: 3 5;
        height: 656px;
      }
    }

    a {
      height: 104px;
      @media (--to-desktop) {
        height: 80px;
      }
    }

    div:nth-of-type(5) {
      @media (--only-tablet) {
        height: 784px;
      }

      @media (--only-mobile) {
        height: 272px;
      }
    }

    @media (--to-desktop) {
      grid-template-rows: repeat(4, 1fr) 80px auto;
    }
  }
`;

export const interiorGalleryGrid = css`
  && {
    @media (--from-desktop) {
      column-gap: 24px;
    }
  }
`;
